package info.rezident.app.data

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import dev.gitlive.firebase.firestore.firestore
import info.rezident.app.core.Logger
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

object ContactRepository {
    private val firestore: FirebaseFirestore = Firebase.firestore

    /**
     * Uploads a contact message to the 'contact' collection in Firestore.
     *
     * @param contactMessage The contact message data to upload
     * @return Boolean indicating success or failure
     */
    suspend fun uploadContactMessage(contactMessage: ContactMessage): Boolean =
        withContext(Dispatchers.Default) {
            try {
                firestore.collection("contact").add(contactMessage)
                true
            } catch (e: FirebaseFirestoreException) {
                Logger.error("Error uploading contact message: ${e.message}")
                false
            } catch (e: Exception) {
                Logger.error("Unexpected error uploading contact message: ${e.message}")
                false
            }
        }
} 